import { createTheme } from '@mui/material/styles';

const fleetTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#1258a8', dark: '#0b3f7a', contrastText: '#ffffff' },
    secondary: { main: '#087e8b' },
    background: { default: '#f4f7fb', paper: '#ffffff' },
    text: { primary: '#172b4d', secondary: '#5c6f86' },
    error: { main: '#b42318' },
    warning: { main: '#9a6700' },
    success: { main: '#16794b' },
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: { fontWeight: 700, letterSpacing: '-0.025em' },
    h5: { fontWeight: 700, letterSpacing: '-0.02em' },
    button: { fontWeight: 700, textTransform: 'none' },
  },
  components: {
    MuiButton: { defaultProps: { disableElevation: true } },
    MuiPaper: { styleOverrides: { rounded: { backgroundImage: 'none' } } },
  },
});

export default fleetTheme;
